import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../components/context/Auth";
import TextElement from "../../components/updatedComponents/FormComponents/TextElement";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import { formatDateTime, getStatusColor } from "../../Utils/Utils";
import styles from "../dashboard/Dispatch.module.css";
import fetchData from "../../APIsControll/apiControll";
import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import { packingVoucherHeader } from "../../constants/constants";
import {
  CancelIcon2,
  DownloadIcon,
  LeftArrow,
  NewEyeIcon,
  Pack,
  Printers,
  SideBarDeliveryIcon,
  SideBarInvoiceIcon,
} from "../../components/icons/Icon";
import { TemplateDone } from "../../components/icons/Icon2";
import { ModalWrapper } from "../../exports";
import Button from "../../components/updatedComponents/Dealers/Button";
import VerticalDropDown2 from "../../components/updatedComponents/FormComponents/VerticalDropDown2";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import RequestForCancelModal from "../../components/updatedComponents/OrderManager/RequestForCancelModal";
import PackOrderModal from "./PackOrderModal";
import DeliveryDetailsModal from "./DeliveryDetailsModal";
import PrintLabelModal from "./PrintLabelModal";
import AcceptOrderModal from "./AcceptOrderModal";
import HandleCancelOrderRequest from "./HandleCancelOrderRequest";
import { useReactToPrint } from "react-to-print";
import DownloadInvoicesModal from "./DownloadInvoicesModal";
import NewPackingSlip from "./NewPackingSlip";
import { useDispatch, useSelector } from "react-redux";
import { setFilter } from "../../store/slices/dispatch/DispatchSlice";
import NewSummarySlip from "./NewSummarySlip";
import MoreDropdown from "./MoreDropdown";

const PackingVoucher = () => {
  const { show } = useToast();
  const { mode, designations, managerId } = useAuth();
  const { orderId } = useParams();
  const navigate = useNavigate();

  const packingSlipRef = useRef(null);
  const masterSummarySlipRef = useRef(null);
  const summarySlipRef = useRef(null);
  const selectedInitRef = useRef(false);

  const { filter } = useSelector((r) => r.dispatch);
  const dispatch = useDispatch();

  const [orderData, setOrderData] = useState({});
  const [shippingAddress, setShippingAddress] = useState({});
  const [itemDetails1, setItemDetails1] = useState([]);
  const [partners, setPartners] = useState([]);
  const [packingManagers, setPackingManagers] = useState([]);
  const [selectedPM, setSelectedPM] = useState({
    label: "Self",
    value: managerId,
  });
  const [selectedPartner, setSelectedPartner] = useState({
    label: "Select",
    value: 0,
  });
  const [selectedPartnerDetails, setSelectedPartnerDetails] = useState({});
  const [invoices, setInvoices] = useState([]);
  const [paymentLink, setPaymentLink] = useState("");
  const [modalContent, setModalContent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [shippingInfo, setShippingInfo] = useState([]);
  const [orderWarehouses, setOrderWarehouses] = useState([]);
  const [packingSlipData, setPackingSlipData] = useState();
  const [partner, setPartner] = useState({});

  const getData = useCallback(async () => {
    setLoading(true);
    try {
      const apiData = {
        managerId: managerId,
        orderId: orderId,
      };
      const data = await fetchData("dispatch/order", apiData);

      if (data.status === "success") {
        setLoading(false);
        setOrderData(data.data.order);
        setShippingAddress(data.data.order.shippingAddress);
        setShippingInfo(data.data.order.shippingInfo);
        setItemDetails1(data.data.order.items);

        // const warehouses = Array.from(
        //   new Set(
        //     data?.data?.order?.shippingInfo
        //       ?.map((item) => item?.warehouseId)
        //       ?.filter((w) => w && w.trim() !== "")
        //   )
        // ).map((name) => ({
        //   label: name,
        //   value: name,
        // }));

        // setOrderWarehouses(warehouses);

        const warehouses = Array.from(
          new Map(
            data?.data?.order?.shippingInfo
              ?.filter(
                (item) => item?.warehouseId && item?.warehouseId.trim() !== "",
              )
              .map((item) => [
                item.warehouseId,
                {
                  value: item.warehouseId,
                  label: item.warehousename,
                },
              ]),
          ).values(),
        );

        setOrderWarehouses(warehouses);

        const warehouse = data?.data?.order?.shippingInfo?.find(
          (s) => s?.warehouseId && s?.warehouseId.trim() !== "",
        );

        const firstWarehouse = warehouse
          ? { label: warehouse.warehousename, value: warehouse.warehouseId }
          : null;

        // console.log("firstWarehouse ", firstWarehouse);

        // const firstWarehouse =
        //   data?.data?.order?.shippingInfo?.find(
        //     (s) => s?.warehouseId && s?.warehouseId.trim() !== ""
        //   )?.warehousename || "";

        if (!selectedInitRef.current) {
          dispatch(
            setFilter({
              selectedOrderWarehouse: firstWarehouse ? firstWarehouse : null,
            }),
          );
          selectedInitRef.current = true;
        }

        const allSameWarehouse = data.data.order.items.every(
          (item, index, array) => item.warehouse === array[0].warehouse,
        );

        setOrderData((prev) => ({
          ...prev,
          isNormalOrder: allSameWarehouse,
        }));

        setPackingManagers(
          data.data.pakingManagers.map((d) => ({
            label: d.name,
            value: d.managerId,
            selectedWarehouse: d.selectedWarehouse,
          })),
        );
        setPartners(data.data.courierPartners);
        setInvoices(data.data.invoices);

        if (data.data.order.shippingType === "Combined") {
          const dispatchInfo = data.data.order.shippingInfo.find(
            (info) => info.isDispatchWarehouse === true,
          );

          if (dispatchInfo) {
            setPartner({
              label: dispatchInfo.delPerName,
              value: dispatchInfo.delPerMobile,
            });
          }
        }
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [dispatch, managerId, orderId]);

  const generatePaymentLink = useCallback(
    async (oId) => {
      setPaymentLink("");
      const currentOrderId = oId || orderId;
      if (!currentOrderId) {
        return;
      }
      try {
        const apiData = { orderId: currentOrderId };
        const result = await fetchData("receipt/generatePaymentLink", apiData);
        if (result.status === "success" && result.shortUrl) {
          const link = `${result.shortUrl}`;
          setPaymentLink(link);
          return link;
        } else {
        }
      } catch (error) {}
    },
    [orderId],
  );

  const generatePackingSlipData = useCallback(async () => {
    try {
      const apiData = {
        managerId: managerId,
        orderId: orderId,
        // warehousename: filter?.selectedOrderWarehouse?.label,
        warehouseId: filter?.selectedOrderWarehouse?.value,
      };
      const res = await fetchData("packing/packingSlip", apiData);
      if (res?.status === "success") {
        setPackingSlipData(res);
      }
    } catch (error) {
      console.error(error);
    }
  }, [managerId, orderId, filter?.selectedOrderWarehouse?.value]);

  useLayoutEffect(() => {
    if (!managerId) return;
    getData();
    generatePaymentLink();
  }, [generatePaymentLink, getData, managerId]);

  useEffect(() => {
    if (!managerId) return;
    if (Object.keys(filter?.selectedOrderWarehouse)?.length !== 0) {
      generatePackingSlipData();
    }
  }, [generatePackingSlipData, managerId, filter?.selectedOrderWarehouse]);

  const acceptOrder = async () => {
    const partnerName =
      selectedPartner.label === "Select"
        ? orderData.partnerName
        : selectedPartner.label;

    const phoneNumber = orderData.whatsapp
      ? orderData.whatsapp
      : orderData.mobile
        ? orderData.mobile
        : "";

    const delPerMobile =
      selectedPartnerDetails?.contactNumber ||
      selectedPartnerDetails?.value ||
      filteredShippingInfo[0]?.delPerMobile;

    const delPerName =
      selectedPartner.label === "Select" ? "" : selectedPartner.label;

    const warehousename = isSuperAdmin
      ? filter?.selectedOrderWarehouse?.label
      : "";

    const warehouseId = isSuperAdmin
      ? filter?.selectedOrderWarehouse?.value
      : "";

    const templateName =
      orderData.paymentMethod === "POD"
        ? "order_placed_pod"
        : "online_order_placed";

    try {
      const apiData = {
        managerId: managerId,
        orderId: orderId,
        pmId: selectedPM.value,
        courierName: filteredShippingInfo[0]?.courierName,
        partnerName: partnerName,
        delPerName: delPerName,
        delPerMobile: delPerMobile,
        delTrackingNo: selectedPartnerDetails.trackingNumber,
        delTrackingUrl: selectedPartnerDetails.trackingUrl,
        warehousename: warehousename,
        warehouseId: warehouseId,
      };

      const apiData2 = {
        managerId: managerId,
        phoneNumber: phoneNumber,
        templateName: templateName,
        headerId: "https://dealer.wallicon.in/assets/order_placed.jpg",
        buttonDataPayload: paymentLink,
      };

      const res = await fetchData("dispatch/acceptOrder", apiData);
      if (res.status === "success") {
        show(res.msg, "success");
        getData();
        sendMessage(apiData2);
      }
      if (res.status === "failed") {
        show(res.msg, "error");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const reqForInvoice = async () => {
    try {
      const apiData = {
        managerId: managerId,
        orderId: orderId,
      };

      const data = await fetchData("invoice/urgentUploadReq", apiData);

      if (data.status === "success") {
        show("Request sent successfully", "success");
        getData();
      }

      if (data.status === "failed") {
        show("Unable to send Request", "error");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const generateLabelData = async (packs) => {
    try {
      const apiData = {
        managerId: managerId,
        orderId: orderId,
        qtyPacks: packs,
        delPerName: orderData.delPerName,
        delPerMobile: orderData.delPerMobile,
        delTrackingNo: orderData.delTrackingNo,
        delTrackingUrl: orderData.delTrackingUrl,
        warehouseId: filter?.selectedOrderWarehouse?.value,
        // warehousename: filter?.selectedOrderWarehouse?.label,
      };

      const res = await fetchData("dispatch/printLabel", apiData);
      if (res.status === "success") {
        show("Label data generated, Opening File!", "success");
        closeModal();
      }
      if (res.status === "failed") {
        show("Unable to generate Label data", "error");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCancelOrder = async (cancelReason) => {
    try {
      const apiData = {
        managerId: managerId,
        orderId: orderId,
        cancelReason: cancelReason,
        warehouseId: filter?.selectedOrderWarehouse?.value,
        // warehousename: filter?.selectedOrderWarehouse?.label,
      };

      const res = await fetchData("dispatch/cancelOrder", apiData);

      if (res.status === "success") {
        show("Order cancelled successfully!", "success");
        getData();
      } else {
        show(res.msg || "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Cancel order failed:", error);
    }
  };

  const sendMessage = async (apiData) => {
    try {
      const res = await fetchData("wallikonChat/sentStatusTemp", apiData);
      if (res.status === "success") {
        getData();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const openModal = (content) => {
    setIsModalOpen(true);
    setModalContent(content);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  const openAcceptOrderModal = () => {
    openModal(
      <AcceptOrderModal
        heading={"Accept Order"}
        centerHeading={"Are you sure you want to accept this order?"}
        targetWord={"order"}
        handleSubmit={acceptOrder}
        handleCloseModal={closeModal}
      />,
    );
  };

  const openPackOrderModal = () => {
    openModal(
      <PackOrderModal
        mode={mode}
        closeModal={closeModal}
        managerId={managerId}
        orderId={orderId}
        getData={getData}
        warehousename={filter?.selectedOrderWarehouse?.label}
        warehouseId={filter?.selectedOrderWarehouse?.value}
        isSuperAdmin={isSuperAdmin}
      />,
    );
  };

  const openDeliveryDetailsModal = () => {
    openModal(
      <DeliveryDetailsModal
        mode={mode}
        closeModal={closeModal}
        managerId={managerId}
        orderId={orderId}
        orderData={orderData}
        partners={filteredPartners}
        getData={getData}
        paymentLink={paymentLink}
        sendMessage={(apiData) => sendMessage(apiData)}
        filteredShippingInfo={filteredShippingInfo}
        warehouseName={filter?.selectedOrderWarehouse?.label}
        warehouseId={filter?.selectedOrderWarehouse?.value}
        allPartners={partners}
        // isDispatchWarehouse={isDispatchWarehouse}
        // partner={partner}
      />,
    );
  };

  const openPrintLabelModal = () => {
    openModal(
      <PrintLabelModal
        mode={mode}
        closeModal={closeModal}
        packs={orderData.packingQty}
        submit={(packs) => generateLabelData(packs)}
        orderData={orderData}
      />,
    );
  };

  const openCancelOrderModal = () => {
    openModal(
      <RequestForCancelModal
        mode={mode}
        handleCloseModal={closeModal}
        handleSubmit={(reason) => {
          if (reason.length < 20) {
            show("Cancel reason must be greater than 10 letters!", "warning");
          } else {
            handleCancelOrder(reason);
          }
        }}
        type={"dispatch"}
      />,
    );
  };

  const openDownloadInvoiceModal = () => {
    openModal(
      <DownloadInvoicesModal
        mode={mode}
        closeModal={closeModal}
        invoices={invoices}
      />,
    );
  };

  // const openPackOrDispatchModal = () => {
  //   openModal(<PackOrDispatchModal mode={mode} closeModal={closeModal} />);
  // };

  const openHandleCancelOrderRequest = useCallback(() => {
    openModal(
      <HandleCancelOrderRequest
        mode={mode}
        managerId={managerId}
        orderId={orderId}
        closeModal={closeModal}
        warehouseName={filter?.selectedOrderWarehouse?.label}
        warehouseId={filter?.selectedOrderWarehouse?.value}
      />,
    );
  }, [managerId, mode, orderId, filter?.selectedOrderWarehouse]);

  const filteredShippingInfo = useMemo(() => {
    if (
      !filter?.selectedOrderWarehouse ||
      !filter?.selectedOrderWarehouse?.value
    )
      return shippingInfo || [];
    return (shippingInfo || []).filter(
      (s) => s.warehouseId === filter?.selectedOrderWarehouse?.value,
    );
  }, [shippingInfo, filter?.selectedOrderWarehouse]);

  const filteredItemDetails = useMemo(() => {
    if (
      !filter?.selectedOrderWarehouse ||
      !filter?.selectedOrderWarehouse?.value
    )
      return itemDetails1 || [];
    return (itemDetails1 || []).filter(
      (it) => it.warehouseId === filter?.selectedOrderWarehouse?.value,
    );
  }, [itemDetails1, filter?.selectedOrderWarehouse]);

  const filteredPackingManagers = useMemo(() => {
    if (
      !filter?.selectedOrderWarehouse ||
      !filter?.selectedOrderWarehouse?.value
    )
      return packingManagers || [];
    return (packingManagers || []).filter(
      (p) => p.selectedWarehouse === filter?.selectedOrderWarehouse?.value,
    );
  }, [packingManagers, filter?.selectedOrderWarehouse]);

  const filteredPartners = useMemo(() => {
    return partners?.filter((partner) => {
      const isSelf = partner?.partnerName === "Self";
      const isRapido = partner?.partnerName === "Rapido & Porter";
      const hasSelectedWarehouse = partner?.selectedWarehouse?.some(
        (w) => w?.warehouseId === filter?.selectedOrderWarehouse?.value,
      );

      return isSelf || isRapido || hasSelectedWarehouse;
    });
  }, [partners, filter?.selectedOrderWarehouse]);

  const isSuperAdmin = designations.includes("superadmin");

  // console.log("filteredItemDetails", filteredItemDetails);

  const isNewOrder =
    filteredShippingInfo[0]?.dispatchStatus === "New Order" &&
    filteredShippingInfo[0]?.packingStatus === "New Order";

  const acceptedByPacker =
    filteredShippingInfo[0]?.dispatchStatus === "New Order" &&
    filteredShippingInfo[0]?.packingStatus === "In Progress";

  const isInProgress =
    filteredShippingInfo[0]?.dispatchStatus === "In Progress" &&
    (filteredShippingInfo[0]?.packingStatus === "In Progress" ||
      filteredShippingInfo[0]?.packingStatus === "New Order");

  const isPacked =
    filteredShippingInfo[0]?.dispatchStatus === "Packed" &&
    filteredShippingInfo[0]?.packingStatus === "Packed";

  const isDispatched =
    filteredShippingInfo[0]?.dispatchStatus === "Dispatched" &&
    filteredShippingInfo[0]?.packingStatus === "Dispatched";

  const isCompleted =
    filteredShippingInfo[0]?.dispatchStatus === "Completed" &&
    filteredShippingInfo[0]?.packingStatus === "Completed";

  const canShowPackingSlip = isSuperAdmin
    ? isInProgress || isPacked || isDispatched
    : isInProgress;

  const showReqForInvoiceBtn =
    filteredShippingInfo[0]?.invoiceStatus === "Pending" ||
    filteredShippingInfo[0]?.invoiceStatus === "OrderReturn" ||
    filteredShippingInfo[0]?.invoiceStatus === "Reupload" ||
    filteredShippingInfo[0]?.invoiceStatus === "Cancelled";

  const showInvoiceReqSentBtn =
    filteredShippingInfo[0]?.invoiceStatus === "Urgent";

  const showDownloadInvoiceBtn =
    filteredShippingInfo[0]?.invoiceStatus === "Uploaded";

  const showHandleCancelOrderRequest =
    orderData?.reqType === "Request For Cancel" &&
    filteredShippingInfo[0]?.reqStatus === "Pending" &&
    filteredShippingInfo[0]?.dmId === parseInt(managerId) &&
    filteredShippingInfo[0]?.dispatchStatus !== "Dispatched" &&
    filteredShippingInfo[0]?.dispatchStatus !== "Completed";

  const isDispatchWarehouse = filteredShippingInfo[0]?.isDispatchWarehouse;

  const isCombined = orderData.shippingType === "Combined";

  const isNormalOrder = orderData.isNormalOrder;

  useEffect(() => {
    if (showHandleCancelOrderRequest) {
      openHandleCancelOrderRequest();
    }
  }, [openHandleCancelOrderRequest, showHandleCancelOrderRequest]);

  useEffect(() => {
    const shippingInfoByWarehouse = shippingInfo?.find(
      (item) => item?.warehouseId === filter?.selectedOrderWarehouse?.value,
    );
    if (
      !shippingInfoByWarehouse?.packermanager ||
      !shippingInfoByWarehouse?.pmId
    ) {
      setSelectedPM({ label: "Self", value: managerId });
    } else {
      setSelectedPM({
        label: shippingInfoByWarehouse?.packermanager,
        value: shippingInfoByWarehouse?.pmId,
      });
    }
    if (!isDispatchWarehouse) {
      setSelectedPartner(partner);
      setSelectedPartnerDetails(partner);
    }
    if (
      !shippingInfoByWarehouse?.partnerName ||
      !shippingInfoByWarehouse?.delPerMobile
    ) {
      // ---------------- change for selected Option when come E-rikshaw ----------------
      // setSelectedPartner({ label: "Select", value: 0 });
      setSelectedPartner({
        label: shippingInfoByWarehouse?.partnerName || "Select",
        value: shippingInfoByWarehouse?.partnerName || 0,
      });
      // --------------------------------------------------------------------------------
    } else {
      setSelectedPartner({
        label: shippingInfoByWarehouse?.partnerName,
        value: shippingInfoByWarehouse?.delPerMobile,
      });
    }

    if (filteredShippingInfo[0]?.methodName !== "E-rickshaw") {
      setSelectedPartner({
        label: filteredShippingInfo[0]?.partnerName,
        value: filteredShippingInfo[0]?.partnerName,
      });
    }
  }, [
    filteredShippingInfo,
    isNewOrder,
    managerId,
    partner,
    filter?.selectedOrderWarehouse,
    shippingInfo,
    isDispatchWarehouse,
  ]);

  const routeName = "Packing Voucher / " + orderId;

  const printPackingSlip = useReactToPrint({
    content: () => packingSlipRef.current,
  });

  const printMasterSummarySlip = useReactToPrint({
    content: () => masterSummarySlipRef.current,
  });

  const printSummarySlip = useReactToPrint({
    content: () => summarySlipRef.current,
  });

  return (
    <div
      className={styles.dispatch}
      style={{
        backgroundColor: mode && "#2C2E33",
        borderColor: mode && "#2C2E33",
      }}
    >
      <ModalWrapper
        isOpen={isModalOpen}
        onClose={
          showHandleCancelOrderRequest
            ? () => setIsModalOpen(true)
            : () => setIsModalOpen(false)
        }
        noBtn
      >
        {modalContent}
      </ModalWrapper>

      <div className={styles.dispatch_top}>
        <div>
          <TopTabBar text={routeName} />
        </div>

        <div className={styles.dispatch_right}>
          <TextElement
            label={"Voucher No. & Date:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={
              orderData.orderId + " / " + formatDateTime(orderData.orderDate)
            }
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"12px"}
            type={"order"}
          />
          <TextElement
            label={"Created By:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={orderData.createdBy}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"12px"}
            type={"order"}
          />
          <TextElement
            label={"Order Manager:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={orderData.ordermanager}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"12px"}
            type={"order"}
          />
          <TextElement
            label={"Status:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={filteredShippingInfo[0]?.dispatchStatus}
            valueColor={getStatusColor(filteredShippingInfo[0]?.dispatchStatus)}
            fontSize={"12px"}
            type={"order"}
          />
        </div>
      </div>

      {loading ? (
        <div>
          <Skeleton
            lines={1}
            thickness={15}
            additionalStyles={{
              marginBottom: "0px",
              marginTop: "0px",
              borderRadius: "15px",
            }}
          />
        </div>
      ) : (
        <div
          className={styles.det_1}
          style={{
            backgroundColor: mode && "#1B1D21",
            borderColor: mode && "#1B1D21",
          }}
        >
          <div className={styles.det_1_sub}>
            <p style={{ color: mode && "#FFFFFF" }}>
              {orderData.storeName} / {shippingAddress.name}
            </p>
            {isSuperAdmin && (
              <div style={{ width: "300px" }}>
                <VerticalDropDown2
                  height={"37px"}
                  fontSize={"12px"}
                  dropDownText={"Select"}
                  value={filter?.selectedOrderWarehouse}
                  options={orderWarehouses}
                  onchange={(option) => {
                    dispatch(setFilter({ selectedOrderWarehouse: option }));
                  }}
                  backgroundColor={mode && "#232529"}
                />
              </div>
            )}
          </div>

          <div className={styles.det_1_sub}>
            <div className={styles.det_1_sub_2}>
              <TextElement
                label={"Address:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={
                  shippingAddress.street +
                  ", " +
                  shippingAddress.city +
                  ", " +
                  shippingAddress.district +
                  ", " +
                  shippingAddress.state +
                  ", " +
                  shippingAddress.pincode
                }
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"14px"}
                fontWeight={"400"}
              />
              <TextElement
                label={"Contact:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={orderData.mobile}
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"14px"}
                fontWeight={"400"}
              />
              <TextElement
                label={"Email:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={orderData.email}
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"14px"}
                fontWeight={"400"}
              />
              <TextElement
                label={"GSTUIN :"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={orderData.gstuin}
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"14px"}
                fontWeight={"400"}
              />
            </div>

            <div className={styles.det_1_sub_2}>
              <TextElement
                label={"Courier Name:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={filteredShippingInfo[0]?.courierName}
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"14px"}
                fontWeight={"400"}
              />
              <TextElement
                label={"Delivery Method:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={filteredShippingInfo[0]?.methodName}
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"14px"}
                fontWeight={"400"}
              />
              <TextElement
                label={"Shipping Type:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={isNormalOrder ? "Normal" : orderData?.shippingType}
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"14px"}
                fontWeight={"400"}
              />
              <TextElement
                label={"Dispatch Warehouse:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={
                  isCombined
                    ? orderData?.dispatchWarehouse
                    : filter?.selectedOrderWarehouse?.label
                }
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"14px"}
                fontWeight={"400"}
              />
              <TextElement
                label={"Packer:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={filteredShippingInfo[0]?.packermanager}
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"14px"}
                fontWeight={"400"}
              />
            </div>
          </div>
        </div>
      )}

      <ul className={styles.p_table}>
        <div
          className={styles.p_table_header_con}
          style={{
            visibility: loading && "hidden",
          }}
        >
          <li
            className={`${styles.p_table_header} ${
              mode ? styles.p_table_header_dark : ""
            }`}
          >
            {packingVoucherHeader?.map((h, index) => (
              <div className={styles.entry_2} key={`${h}-${index}`}>
                {h}
              </div>
            ))}
          </li>
        </div>

        {filteredItemDetails?.map((item, index) => (
          <div className={styles.p_table_list} key={item.itemNo + "-" + index}>
            <>
              {loading ? (
                <div>
                  <Skeleton
                    lines={
                      filteredItemDetails?.length === 1
                        ? 1
                        : filteredItemDetails?.length / 2
                    }
                    thickness={5}
                    additionalStyles={{
                      marginBottom: "0px",
                      marginTop: "0px",
                    }}
                  />
                </div>
              ) : (
                <li
                  className={`${styles.p_table_row} ${
                    mode ? styles.p_table_row_dark : ""
                  }`}
                  key={item.itemNo + index}
                >
                  <div className={styles.entry_2}> {index + 1} </div>
                  <div className={styles.entry_2}>{item.itemNo}</div>
                  <div className={styles.entry_2}> {item.product_name} </div>
                  <div className={styles.entry_2}>{item.warehouse}</div>
                  <div className={styles.entry_2}>{item.qty}</div>
                  <div className={styles.entry_2}> {item.unit}</div>
                </li>
              )}
            </>
          </div>
        ))}
      </ul>

      <footer className={`${styles.footer} ${mode ? styles.footer_dark : ""}`}>
        <div className={styles.footer_left}>
          <TextElement
            label={"Total Items:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={filteredItemDetails?.length}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"14px"}
            fontWeight={"400"}
          />
          <div className={styles.footer_dds}>
            <div>
              <VerticalDropDown2
                height={"37px"}
                fontSize={"12px"}
                dropDownText={"Select"}
                label={"Select Packer"}
                value={selectedPM}
                options={filteredPackingManagers}
                onchange={(option) => {
                  setSelectedPM(option);
                }}
                openUpwards={true}
                disableOpen={!isNewOrder}
              />
            </div>
            <div>
              <VerticalDropDown2
                height={"37px"}
                fontSize={"12px"}
                label={"Select Partner"}
                value={selectedPartner}
                options={filteredPartners?.map((p) => ({
                  label: p?.partnerName,
                  value: p?.contactNumber,
                }))}
                onchange={(v) => {
                  setSelectedPartner(v);
                  const foundPartner = partners?.find(
                    (p) => p?.contactNumber === v?.value,
                  );
                  setSelectedPartnerDetails(foundPartner || null);
                }}
                openUpwards={true}
                disableOpen={isDispatched || isCompleted}
              />
            </div>
          </div>
        </div>

        {!loading && (
          <div className={styles.btn_wrapper}>
            {/* --------------------------- Summary ------------------------------------- */}
            {canShowPackingSlip && (
              <MoreDropdown
                mode={mode}
                isSuperAdmin={isSuperAdmin}
                onSummaryClick={() => {
                  printMasterSummarySlip();
                  // show("Coming soon...");
                }}
                onSlipClick={() => {
                  printSummarySlip();
                  // show("Coming soon...");
                }}
              />
            )}

            {/* -------------------------------------------------------------- */}
            <div>
              <Button
                buttonIcon={<LeftArrow color={"#FFFFFF"} />}
                buttonText={"Back"}
                buttonBgColor={"#000000"}
                buttonTextColor={"#ffffff"}
                buttonClick={() => navigate(-1)}
              />
            </div>

            {(isNewOrder || acceptedByPacker) && (
              <div>
                <Button
                  buttonIcon={<TemplateDone />}
                  buttonText={"Accept"}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#ffffff"}
                  buttonClick={openAcceptOrderModal}
                />
              </div>
            )}

            {(isInProgress || isPacked || isDispatched) && (
              <div>
                <Button
                  buttonIcon={<CancelIcon2 />}
                  buttonText={"Cancel Order"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonClick={openCancelOrderModal}
                />
              </div>
            )}

            {/* {isInProgress && (
              <div>
                <Button
                  buttonIcon={<Printers color="#FFFFFF" />}
                  buttonText={"Packing Slip"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonClick={printPackingSlip}
                />
              </div>
            )} */}

            {canShowPackingSlip && (
              <div>
                <Button
                  buttonIcon={<Printers color="#FFFFFF" />}
                  buttonText={"Packing Slip"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonClick={printPackingSlip}
                />
              </div>
            )}

            {isPacked && (
              <div>
                <Button
                  buttonIcon={<SideBarDeliveryIcon color="#FFFFFF" />}
                  buttonText={"Delivery Details"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonClick={openDeliveryDetailsModal}
                />
              </div>
            )}

            {(isDispatched || isCompleted) && (
              <div>
                <Button
                  buttonIcon={<NewEyeIcon />}
                  buttonText={"Dispatch Details"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonClick={() =>
                    navigate(
                      "/dispatch/details/" +
                        orderId +
                        "/" +
                        filter?.selectedOrderWarehouse?.value,
                    )
                  }
                />
              </div>
            )}

            {!isNewOrder && !acceptedByPacker && (
              <>
                {(showReqForInvoiceBtn || isSuperAdmin) && (
                  <div>
                    <Button
                      buttonTextColor={"#FFFFFF"}
                      buttonBgColor={"#4164E3"}
                      buttonIcon={<SideBarInvoiceIcon color="#FFFFFF" />}
                      buttonText={"Request for Invoice"}
                      buttonClick={reqForInvoice}
                    />
                  </div>
                )}

                {showInvoiceReqSentBtn && (
                  <div>
                    <Button
                      buttonIcon={<SideBarInvoiceIcon color="#FFFFFF" />}
                      buttonTextColor={"#FFFFFF"}
                      buttonBgColor={"#FF9B04"}
                      buttonText={"Invoice Pending"}
                    />
                  </div>
                )}

                {showDownloadInvoiceBtn && (
                  <div>
                    <Button
                      buttonTextColor={"#FFFFFF"}
                      buttonBgColor={"#4164E3"}
                      buttonIcon={<DownloadIcon />}
                      buttonText={"Download Invoice"}
                      buttonClick={openDownloadInvoiceModal}
                    />
                  </div>
                )}
              </>
            )}

            {(isPacked || isDispatched || isCompleted) && (
              <div>
                <Button
                  buttonIcon={<Printers color="#FFFFFF" />}
                  buttonText={"Label"}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#ffffff"}
                  buttonClick={openPrintLabelModal}
                />
              </div>
            )}

            {isInProgress && (
              <div>
                <Button
                  buttonIcon={<Pack />}
                  buttonText={"Pack"}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#ffffff"}
                  buttonClick={openPackOrderModal}
                />
              </div>
            )}
          </div>
        )}
      </footer>

      <div style={{ display: "none" }}>
        <NewPackingSlip
          ref={packingSlipRef}
          packingSlipData={packingSlipData}
          order={orderData}
          // currentWarehouse={filter?.selectedOrderWarehouse?.label}
          currentWarehouse={filter?.selectedOrderWarehouse?.value}
          filterItem={filteredItemDetails}
          totalQty={filteredItemDetails.length}
        />
      </div>

      {/* ------------ Summary Slip ------------------- */}

      <div style={{ display: "none" }}>
        <NewSummarySlip
          ref={masterSummarySlipRef}
          summarySlipData={packingSlipData}
        />
      </div>

      <div style={{ display: "none" }}>
        <NewSummarySlip
          ref={summarySlipRef}
          summarySlipData={packingSlipData}
          currentWarehouse={filter?.selectedOrderWarehouse?.value}
          currentWarehouseName={filter?.selectedOrderWarehouse?.label}
        />
      </div>
    </div>
  );
};
export default PackingVoucher;

//? https://excalidraw.com/#json=C9rXvU_iN3q3dCDJs-XZ0,UbUQVagHbn5caZi0TxnJGA
